import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
import { jsxs, jsx } from 'react/jsx-runtime';
import { Card } from '@design-system/card';
import classNames from 'classnames';
var BASE_CLASS = 'cds-page-card';
var PageCard = function PageCard(_ref) {
  var className = _ref.className,
    link = _ref.link,
    variant = _ref.variant,
    cardContent = _ref.cardContent,
    cardCta = _ref.cardCta,
    cardMedia = _ref.cardMedia,
    cardLabel = _ref.cardLabel,
    categories = _ref.categories;
  var headingBlock = cardContent.headingBlock,
    disclaimer = cardContent.disclaimer,
    category = cardContent.category;
  var headingBlockWithLink = Object.assign(Object.assign({}, headingBlock), {
    headlineLink: link
  });
  var categoryClasses = (categories === null || categories === void 0 ? void 0 : categories.map(function (title) {
    return "".concat(BASE_CLASS, "--").concat(title);
  })) || [];
  return jsxs(Card, Object.assign({
    className: classNames.apply(void 0, [BASE_CLASS].concat(_toConsumableArray(categoryClasses), [className])),
    hasMedia: !!cardMedia,
    variant: variant
  }, {
    children: [jsx(Card.CardContent, Object.assign({
      headingBlock: headingBlockWithLink,
      disclaimer: disclaimer,
      category: category
    }, {
      children: cardCta && jsx(Card.CardCTA, Object.assign({}, cardCta))
    })), cardMedia || cardLabel ? jsx(Card.CardMedia, Object.assign({}, variant === 'standard' ? {
      mediaVariant: 'rounded'
    } : {}, cardMedia, {
      children: cardLabel && jsx(Card.CardLabel, Object.assign({}, cardLabel))
    })) : null]
  }));
};
export { PageCard };